export default __webpack_public_path__ + "static/media/gallery_08.81245d82.jpg";